import { appealRoute } from '../../admin/appeals/routes.js';
import { memberReportRoute } from '../../admin/moderation/routes.js';
export const moderationRoutes = {
    report: memberReportRoute,
    appeal: appealRoute,
};
//# sourceMappingURL=routes.js.map